/**
 * 动态加载阿里播放器
 * 按需引入,避免全局加载
 */

let aliplayerLoaded = false
let aliplayerLoading = false
const callbacks = []

/**
 * 加载阿里播放器的 CSS 和 JS
 * @returns {Promise<void>}
 */
export function loadAliplayer() {
  return new Promise((resolve, reject) => {
    // 如果已经加载完成
    if (aliplayerLoaded) {
      resolve()
      return
    }

    // 如果正在加载中,将回调加入队列
    if (aliplayerLoading) {
      callbacks.push({ resolve, reject })
      return
    }

    // 开始加载
    aliplayerLoading = true

    // 加载 CSS
    const link = document.createElement('link')
    link.rel = 'stylesheet'
    link.href = 'https://g.alicdn.com/de/prismplayer/2.12.1/skins/default/aliplayer-min.css'
    document.head.appendChild(link)

    // 加载 JS
    const script = document.createElement('script')
    script.charset = 'utf-8'
    script.type = 'text/javascript'
    script.src = 'https://g.alicdn.com/de/prismplayer/2.12.1/aliplayer-min.js'
    
    script.onload = () => {
      aliplayerLoaded = true
      aliplayerLoading = false
      
      // 执行当前 Promise
      resolve()
      
      // 执行队列中的所有回调
      callbacks.forEach(cb => cb.resolve())
      callbacks.length = 0
    }

    script.onerror = (error) => {
      aliplayerLoading = false
      
      // 执行当前 Promise
      reject(new Error('阿里播放器加载失败'))
      
      // 执行队列中的所有回调
      callbacks.forEach(cb => cb.reject(error))
      callbacks.length = 0
    }

    document.head.appendChild(script)
  })
}

/**
 * 检查阿里播放器是否已加载
 * @returns {boolean}
 */
export function isAliplayerLoaded() {
  return aliplayerLoaded || (typeof window.Aliplayer !== 'undefined')
}

